var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifi({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "42px",
    height: "39px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: "0px",
    y: "0px",
    width: "42px",
    height: "39px",
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAnCAQAAADTVBIOAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfoAhQSLTSNRHmjAAACkUlEQVRIx9VWzZmjMAx9k2/veBuYaCoIHYSpIOkgdDBJA5kSmK2A7SAlkKkATnuFqQCmAu1Blm3CX3LYw+IDSNaTn2RZBgw3KC3SginQ3DcGuGDqPQeDH3ZLaQEGv+ce56YuR/18zx9xKlTA4MtR3VpNGxs7FXEbP+K0jSP7aRyyFzo44nL/aPjlXt1qCm54usxQkS449xaOknIFg/F2EeVaA6DLcWHLKC18Ftt4bdVvF3VKcSuq/CxGdSLMJ93aHXdZpPwsE3HLxACjTtRWTQ6FaupkzKlHHArlGiLAyDIRd6XyVIMsc0zJDispxi1Lu9Ji/jDAUDE/i50C1qwbUSf70rDhfVknqlv7hcFgaAJ2zABjW4tYpDLt1sz6GZYsKrMgPjAYRSrylhkr0LcBAMB0AAD6IpGTTzQA6JjJBAB0OGYgAE3yKZovAgVofAMEJmWhgd3KnqdwnbLz8gqLD/ekaBmAFbCxxKtY3rdyUoWAuJq33nTACo1mo5PcNtSIfN1K9j5Onl2Ej5Nk+roVDTVoAjRMh2blU9w8W2ZXef86Kqx63VURIuyq6lWX1Nn9pY82Hf5B8WeLx3S8t/pDOXlMmTaDhhL15GFDkfMTDRrKRhuKb33Ua32BSwpG4Na3PlXLVWTDue3dTO6UjxV63yK4N4ImHfbu0etkzKmbK/fmhpJL/fD6us+pv4rcvYGVVtfvk7aMa3LHSXTPNbFljo+TVnzARlIwuuOz4cvOj/1M2PqcKKI5p2DKz4eJ3565Me90MH4spIwmNM0sap5hkZqB0vDSj8YT09ySP+tuRGvQvsyhnpie6kdKaPnhlzuuk8ef/8fpwkaZ+ntEu0Yzu1GLJRUNlNEdJTUfyVQczRzoL/Fhhx1Es1n1AAAAAElFTkSuQmCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.39f3d3d232e4210205db581d398d600b.svg";
export { ForwardRef as ReactComponent };